var map = {
	"./symbol_0.png": "f97a",
	"./symbol_1.png": "562f",
	"./symbol_2.png": "375b",
	"./symbol_3.png": "2e80",
	"./symbol_4.png": "c6cd",
	"./symbol_5.png": "876c",
	"./symbol_6.png": "510e",
	"./symbol_7.png": "cdbc",
	"./symbol_8.png": "dc3c",
	"./symbol_9.png": "7554"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9c9";